import {logout} from "../../../../helpers/index.js";

export default {
  methods: {
    pushTelaComprasPorDepartamentos({id_grupo, id_filial = 9999, id_departamento}) {
      const rota = {
        name: 'compras_por_departamentos',
        params: {id_grupo, id_filial, id_departamento}
      };

      this.$router.push(rota).catch(() => logout());
    }
  }
}
